import axios from 'crypto-fetch/axios.js'
import { cancelPending } from '@ms/utils/cancel-pending.js'
import { isBetBuilderSelection } from '@ms/stores/betslip/func.js'

export function fetchBetBuilderOdds({ eventId = '', betBuilderSelections = [] }) {
  const cancelKey = `${eventId}/bet-builder/odds`
  cancelPending.cancel(cancelKey)
  const body = betBuilderSelections.map((x) => {
    const { marketInfo, outcomeInfo } = x
    return {
      marketId: marketInfo.id,
      specifier: marketInfo.specifiers,
      outcomeId: outcomeInfo.id
    }
  })
  return axios.post(`/facts-center/query/frontend/match/${eventId}/bet-builder/odds`, body, {
    ...cancelPending.getCancelToken(cancelKey)
  })
}

export const fetchShareCode = (shareCode = '') => {
  return axios.get(`/orders/real-sports/order/share/${shareCode}`)
}

export const shareBetCode = (selectionList = []) => {
  const selections = selectionList.map((x) => {
    if (isBetBuilderSelection(x)) {
      return {
        eventId: x.eventId,
        customizedMarketType: 1,
        subSelections: x.betBuilderSelections.map((item) => {
          return {
            eventId: item.eventId,
            marketId: item.marketInfo.id,
            specifier: item.marketInfo.specifiers,
            outcomeId: item.outcomeInfo.id
          }
        })
      }
    } else {
      return {
        eventId: x.eventId,
        marketId: x.marketInfo.id,
        specifier: x.marketInfo.specifiers,
        outcomeId: x.outcomeInfo.id
      }
    }
  })

  const body = {
    selections
  }

  return axios.post('/orders/real-sports/order/share', body)
}
